import React from "react";

export default class MonthlyGanttTable extends React.Component {

    state = {

        cells: [
            {}, {}, {}, {}, {}, {},
            {}, {}, {}, {}, {}, {},
       
        ]

    }
    render() {


        return (
            <div style={{ height: "600px", border: "0.1px solid #EBEDF1", borderBottom: "none", borderTop: "none", display: "flex", flexDirection: "row" }}>
                {this.state.cells.map((cell, index) => {
                    return (

                        <div className="cell"
                        style={{ width: "100px" }}
                        >


                        </div>
                    )

                })}
            </div>

        )
    }
}